import { BelongsToReferenceField, pageCollectionFields } from 'drapcode-constant';
import { getCollectionFields } from '../pluginComponentApi';
export default (editor, opts) => {
  const dc = editor.DomComponents;
  const { type, label, projectId, collections, pageCollection } = opts;
  const defaultType = dc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;

  console.log('🚀 ~ components: calendar ~ collections:', collections);

  let options = [{ value: '', name: '- Select Collection -', disabled: true }];
  collections.forEach((item) => {
    options.push({ value: item.collectionName, name: item.collectionTitle });
  });
  console.log('🚀 ~ components: calendar ~ options:', options);

  dc.addType(type, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          'custom-name': label,
          projectId: projectId,
          // droppable: false, // Can't drop other elements inside
          droppable: ['form', 'search-form'], // Can drop data-search form component inside
          icon: '<i class="wb webconnect-calendar-week"></i>',
          collectionName: '',
          collectionFrom: '',
          finderUuid: '',
          traits: [
            {
              type: 'data-calendar-collection',
              label: false,
              name: 'collectionName',
              changeProp: 1,
            },
            {
              type: 'webconnect-event',
              label: 'Event',
              name: 'data-onClick',
            },
            ...dc.getType('default').model.prototype.defaults.traits,
            {
              name: 'data-calendar-view',
              label: 'Default View',
              title: `Default View`,
              type: 'select',
              options: [
                { value: '', name: 'Month (Default)' },
                { value: 'timeGridWeek', name: 'Week' },
                { value: 'timeGridDay', name: 'Day' },
                { value: 'listWeek', name: 'List' },
              ],
            },
          ],
          script: function () {
            if (typeof loadCalendarComponent !== 'undefined') {
              console.log('*** Loading Calendar script...');
              const collectionId = '{[ collectionName ]}';
              const finderId = '{[ finderUuid ]}';
              const collectionFrom = '{[ collectionFrom ]}';

              let calendarDataObj = {};
              const calendarComp = this.cloneNode(true);

              let selectedCollectionData = '{[ selectedCollectionStr ]}';
              selectedCollectionData = selectedCollectionData.replaceAll('**##', '"');

              calendarDataObj.collectionName = collectionId;
              calendarDataObj.finderId = finderId;
              calendarDataObj.collectionFrom = collectionFrom;
              calendarDataObj.originalCalendar = calendarComp;
              calendarDataObj.calendarChildren = calendarComp ? calendarComp.children : [];

              const externalQueryParamKeys = [];
              if (selectedCollectionData && selectedCollectionData !== 'undefined') {
                selectedCollectionData = JSON.parse(selectedCollectionData);
                const selectedFilter = selectedCollectionData.finders.find(
                  (finder) => finder.uuid === finderId,
                );

                if (selectedFilter && selectedFilter.conditions) {
                  selectedFilter.conditions.forEach((condition) => {
                    if (condition.requiredExternal) {
                      const {
                        query: { value },
                      } = condition;
                      if (value.includes('---')) {
                        const values = value.split('---');
                        externalQueryParamKeys.push(values[0]);
                        externalQueryParamKeys.push(values[1]);
                      } else {
                        externalQueryParamKeys.push(value);
                      }
                    }
                  });
                }
              }
              calendarDataObj.externalQueryParamKeys = externalQueryParamKeys;
              const search = this.querySelector('.search-form');
              if (search) {
                calendarDataObj.searchComponent = search;
                search.addEventListener('submit', function (ev) {
                  ev.preventDefault();
                  calendarDataObj['event'] = ev;
                  console.log(
                    '🚀 ~ Calendar SCRIPT typeof searchInCalendar:',
                    typeof searchInCalendar,
                  );
                  if (typeof searchInCalendar !== 'undefined') {
                    searchInCalendar(calendarDataObj);
                  }
                });

                const enableAutoSearch = search.hasAttribute('data-enableautosearch');
                console.log('🚀 ~ Calendar SCRIPT enableAutoSearch:', enableAutoSearch);
                console.log(
                  '🚀 ~  Calendar SCRIPT typeof autoSearchInCalendarDataSearch:',
                  typeof autoSearchInCalendarDataSearch,
                );
                calendarDataObj.enableAutoSearch = enableAutoSearch;
                if (
                  typeof searchInCalendar !== 'undefined' &&
                  typeof autoSearchInCalendarDataSearch !== 'undefined' &&
                  enableAutoSearch
                ) {
                  autoSearchInCalendarDataSearch(enableAutoSearch, search);
                }
              }

              loadCalendarComponent(this, calendarDataObj);
            }
          },
        },
        init() {
          //Populate Previous External Query from Collection Finder
          const collection = this.get('selectedCollectionData');
          const finder = this.get('finderUuid');
          const finders = collection ? collection.finders : [];
          const selectedFinder = finders.find((currentFinder) => currentFinder.uuid === finder);
          if (selectedFinder && selectedFinder.noOfExternalParams > 0) {
            let pageCollectionOptions = pageCollection ? pageCollection.options : [];
            pageCollectionOptions = pageCollectionOptions.filter((opt) =>
              [...pageCollectionFields, ...BelongsToReferenceField].includes(opt.type),
            );
            const externalQueryParamKeys = [];
            if (selectedFinder.conditions) {
              selectedFinder.conditions.forEach((condition) => {
                if (condition.requiredExternal) {
                  const {
                    query: { value },
                  } = condition;
                  if (value.includes('---')) {
                    const values = value.split('---');
                    externalQueryParamKeys.push(values[0]);
                    externalQueryParamKeys.push(values[1]);
                  } else {
                    externalQueryParamKeys.push(value);
                  }
                }
              });
            }

            if (externalQueryParamKeys.length > 0) {
              externalQueryParamKeys.forEach((extParam) => {
                this.addTrait({
                  name: extParam,
                  label: extParam,
                  options: pageCollectionOptions,
                  title: extParam,
                  type: 'finder-query-param-trait',
                });
              });
            }
          }
          this.on('change:collectionName', this.handleCollectionChange);
          this.on('change:finderUuid', this.handleFinderChange);
        },
        async handleCollectionChange() {
          const collectionName = this.get('collectionName');
          const collectionResponse = await getCollectionFields(collectionName, collections);
          if (collectionResponse) {
            this.removeTrait('data-event-title');
            this.removeTrait('data-event-starttime');
            this.removeTrait('data-event-endtime');
            this.removeTrait('data-event-duration');
            this.removeTrait('data-event-url');
            this.removeTrait('finderUuid');
          }
        },
        async handleFinderChange() {
          const collectionName = this.get('collectionName');
          const collection = this.get('selectedCollectionData');
          const finder = this.get('finderUuid');
          const finders = collection ? collection.finders : [];
          const selectedFinder = finders.find((currentFinder) => currentFinder.uuid === finder);
          const allTraits = this.get('traits');
          const removeTraits = [];
          allTraits.forEach((trait) => {
            if (trait.props().type === 'finder-query-param-trait') {
              removeTraits.push(trait.props().name);
            }
          });
          removeTraits.map((trait) => this.removeTrait(trait));

          if (selectedFinder && selectedFinder.noOfExternalParams > 0) {
            let pageCollectionOptions = pageCollection ? pageCollection.options : [];
            pageCollectionOptions = pageCollectionOptions.filter((opt) =>
              [...pageCollectionFields, ...BelongsToReferenceField].includes(opt.type),
            );
            const externalQueryParamKeys = [];
            if (selectedFinder.conditions) {
              selectedFinder.conditions.forEach((condition) => {
                if (condition.requiredExternal) {
                  const {
                    query: { value },
                  } = condition;
                  if (value.includes('---')) {
                    const values = value.split('---');
                    externalQueryParamKeys.push(values[0]);
                    externalQueryParamKeys.push(values[1]);
                  } else {
                    externalQueryParamKeys.push(value);
                  }
                }
              });
            }

            if (externalQueryParamKeys.length > 0) {
              externalQueryParamKeys.forEach((extParam) => {
                this.addTrait({
                  name: extParam,
                  label: extParam,
                  options: pageCollectionOptions,
                  title: extParam,
                  type: 'finder-query-param-trait',
                });
              });
            }
          }
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === type) {
            return {
              type: type,
            };
          }
        },
      },
    ),
    view: defaultView,
  });
};
